import type {ReactElement} from 'react';
import React from 'react';
import {ControlledListItemType1} from '@Components/controlled-list/components/controlled-list-item-type-1';
import {useAppDispatch, useAppSelector} from '@/hooks';
import {updateListItemSelectionState} from '../../list-reducer';
import type {LIST_ITEM_TYPE, ListDefaultItemBaseStorage} from '../../list.types';
import type {ThumbnailData} from '@Components/thumbnail/thumbnail.types';

interface ListItemType1Props {
  id: string;
  listId: string;
  isDraggable?: boolean;
}

export interface ListItemType1Storage extends ListDefaultItemBaseStorage, ListBaseItemType1Storage {
  type: LIST_ITEM_TYPE.DEFAULT_1;
}

interface ListBaseItemType1Storage {
  subtext?: string;
  loading?: boolean;
  additionalData?: Record<string, any>;
  thumbnail?: ThumbnailData;
  showEditIcon?: boolean;

  onClickEditIcon?(listId: string, listItemId: string): void;
}

export function ListItemType1({isDraggable = false, ...props}: ListItemType1Props): ReactElement<any> | null {
  const dispatch = useAppDispatch();
  const listItemData = useAppSelector((state) => {
    return state.list.listItemData.listItemsHashMap[props.id] as ListItemType1Storage;
  });

  const onClickHandler = (): void => {
    if (listItemData.loading) {
      return;
    }

    if (listItemData.onClick) {
      listItemData.onClick(props.listId, props.id);
    }

    dispatch(
      updateListItemSelectionState({
        listId: props.listId,
        id: props.id,
      })
    );
  };

  const onClickEditIcon = (): void => {
    if (listItemData.onClickEditIcon) {
      listItemData.onClickEditIcon(props.listId, props.id);
    }
  };

  const displayListItem = (): ReactElement<any> => {
    return (
      <ControlledListItemType1
        isDraggable={isDraggable}
        text={listItemData.text}
        id={listItemData.id}
        className={listItemData.className}
        isSelected={listItemData.isSelected}
        loading={listItemData.loading}
        onClick={onClickHandler}
        onClickEditIcon={onClickEditIcon}
        thumbnail={listItemData.thumbnail}
        showEditIcon={listItemData.showEditIcon}
        subText={listItemData.subtext}
      />
    );
  };

  return listItemData ? displayListItem() : null;
}
